export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  imageUrl: string;
  tags: string[];
  readTime: number;
  featured: boolean;
}

export const categories = [
  { name: '情感故事', slug: 'qinggan-gushi', description: '那些藏在心底的青春情感记忆' },
  { name: '成长记忆', slug: 'chengzhang-jiyi', description: '从懵懂到成熟的成长历程' },
  { name: '心理分析', slug: 'xinli-fenxi', description: '青春期情感心理深度解析' },
  { name: '青春文学', slug: 'qingchun-wenxue', description: '青春主题文学作品与感悟' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '朋友的姐姐，我青春里最温柔的秘密',
    excerpt: '那年夏天，我第一次见到她的笑容。阳光透过梧桐叶洒在她身上，像极了电影里的画面。她是朋友的姐姐，却成了我整个青春期最深的暗恋。',
    content: `<p>十四岁那年暑假，我第一次去朋友小磊家。门一打开，站在玄关的不是小磊，而是一个穿着浅蓝色连衣裙的女生。她冲我笑了一下，那笑容像夏天的第一口冰西瓜，清甜到让人忘了呼吸。</p>
<p>"你是小磊的同学吧？他在房间里，快进来。"她的声音很轻，像春风拂过耳畔。</p>
<p>那是我第一次见到李姐——小磊的姐姐，那年她十七岁，刚考上省重点高中。在我眼里，她就是全世界最完美的人。她成绩好、会弹钢琴、笑起来有两个浅浅的梨涡，连说话的语气都带着一种让人安心的温柔。</p>
<p>从那天起，我开始找各种借口去小磊家。说是借书，其实是想碰运气见到她。说是打球，其实是期待她路过球场时的那个害羞的微笑。说是写作业，其实是想在她辅导我们的时候，偷偷多看她几眼。</p>
<p>我记得有一次，她教我们做数学题。她坐在我旁边，头发垂下来，有淡淡的洗发水香味。她指着那道几何题，认真地给我讲解，而我一个字都没听进去，只是不停地点头，心跳得像擂鼓。她似乎察觉到了什么，抬头看了我一眼，然后轻轻地笑了——那个笑容里有种了然于心的温柔，她什么都知道，但她什么都不说。</p>
<p>那段暗恋持续了整整两年。我写了无数封从未寄出的信，在本子上偷偷画她的侧脸，听她喜欢的歌，读她推荐的书。后来小磊无意中告诉我，李姐说我是她见过最可爱的弟弟。那个"弟弟"二字，让我在深夜里辗转反侧了无数次。</p>
<p>很多年后，我在同学聚会上又见到了李姐。她结了婚，有了孩子，笑容依旧温柔。我们聊了几句，她笑着说："你长大了，和小时候完全不一样了。"我也笑，心里涌起一阵暖流。那场暗恋早已随风散去，但那份温柔的记忆，却成了我青春里最珍贵的宝藏。</p>
<p>朋友的姐姐，是青春赠予我们的一场温柔的暗恋练习课。她教会了我们什么是喜欢，什么是仰望，什么是把秘密藏在心底的美好。即使最后没有结果，那段心跳加速的时光，也足够温暖此后漫长的岁月。</p>`,
    category: '情感故事',
    categorySlug: 'qinggan-gushi',
    author: '心语',
    date: '2026-08-01',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Warm%20nostalgic%20summer%20scene%20with%20sunlight%20filtering%20through%20sycamore%20leaves%2C%20a%20young%20girl%20in%20light%20blue%20dress%20standing%20by%20doorway%2C%20soft%20golden%20hour%20lighting%2C%20dreamy%20atmosphere%2C%20artistic%20illustration%20style%2C%20warm%20amber%20and%20cream%20tones%2C%20nostalgic%20Chinese%20youth%20aesthetic%2C%20delicate%20watercolor%20texture%2C%20emotional%20and%20tender%20mood&width=800&height=500&seq=article-1-01&orientation=landscape',
    tags: ['暗恋', '青春', '朋友的姐姐', '初恋记忆'],
    readTime: 8,
    featured: true,
  },
  {
    id: 'article-2',
    title: '为什么我们总是暗恋朋友的姐姐？揭秘青春期的情感心理',
    excerpt: '从心理学角度分析，朋友的姐姐为什么总成为少年心中的"女神"？这背后隐藏着青春期独特的心理需求和情感发展规律。',
    content: `<p>如果你问一个青春期男孩，他第一个暗恋对象是谁，答案出奇地一致——要么是班里的女老师，要么是朋友的姐姐。这个现象如此普遍，以至于它几乎成了青春期的一种"标配"情感经历。</p>
<p><strong>成熟感的致命吸引力</strong></p>
<p>在青春期的情感发展过程中，同龄女生和年长女性之间存在一个关键差距——成熟度。朋友的姐姐通常比我们大3到5岁，正处于从少女向成熟女性转变的阶段。她们的一举一动都带着一种同龄女生尚未具备的从容和优雅。这种"若即若离"的成熟气质，对正处在情感探索期的少年来说，具有不可抗拒的吸引力。</p>
<p><strong>安全距离下的情感投射</strong></p>
<p>心理学上有一个重要概念叫"安全距离效应"。暗恋朋友的姐姐是一种"安全的暗恋"——因为身份的特殊性，这段感情从一开始就被设定为"不可能"。正因为知道不可能，少年反而可以放心地把所有美好的想象都投射到她身上。她不只是一个真实的人，更是一个承载了青春期所有理想化想象的"情感容器"。</p>
<p><strong>"可得性"与"不可得性"的完美平衡</strong></p>
<p>朋友姐姐的特殊之处在于，她在"可得"和"不可得"之间找到了一个微妙的平衡点。她不像明星那样遥不可及，也不像同龄女生那样近在咫尺。你能见到她、和她说话、甚至被她摸头，但你知道她不会被你追到。这种恰到好处的距离感，让暗恋变成了一段既甜蜜又安全的心理体验。</p>
<p><strong>情感启蒙的"练习场"</strong></p>
<p>从发展心理学的角度看，暗恋朋友的姐姐其实是青春期情感能力的一次"模拟训练"。通过这段无压力的单向情感投射，少年学会了什么是喜欢、如何管理自己的情感、怎样处理单相思带来的甜蜜和酸涩。这些情感技能，会在他们日后遇到真正双向的感情时，发挥重要的作用。</p>
<p>所以，如果你曾经暗恋过朋友的姐姐，不要觉得是自己"奇怪"或"不成熟"。这是几乎每个男生在青春期都会经历的情感必修课——一个让你学会爱与被爱的温柔起点。</p>`,
    category: '心理分析',
    categorySlug: 'xinli-fenxi',
    author: '心语',
    date: '2026-07-28',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Abstract%20psychological%20concept%20art%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20gradient%20shapes%20representing%20emotions%2C%20gentle%20curves%20and%20flowing%20forms%2C%20dreamy%20atmosphere%2C%20minimalist%20composition%2C%20tender%20and%20introspective%20mood%2C%20artistic%20illustration&width=800&height=500&seq=article-2-01&orientation=landscape',
    tags: ['心理分析', '青春期情感', '暗恋心理', '情感发展'],
    readTime: 10,
    featured: true,
  },
  {
    id: 'article-3',
    title: '那个夏天，她教会我的不止是喜欢',
    excerpt: '她是我朋友的表姐，一个在东京学设计的女孩。那年暑假她回国探亲，我偶然在她房间里看到了一整面墙的素描——那些画里，全是我。',
    content: `<p>高二那年暑假，朋友林浩说他表姐从东京回国探亲，要在他们家小住一个月。林浩说起他表姐时，语气里满是骄傲："我姐超厉害的，在日本学服装设计，还拿过奖。"我随口附和了几句，心里却没有任何特别的期待。</p>
<p>直到那个周四下午，我和林浩在他家客厅打游戏，门外传来钥匙转动的声音。门开了，一个穿着白色T恤和牛仔裤的女生走了进来，手里拎着画板和帆布袋。她的头发是自然的微卷，皮肤很白，整个人干净得像日剧里的女主角。</p>
<p>"你们好啊。"她冲我们点了点头，眼睛弯成两道月牙。</p>
<p>就是那一瞬间的点头微笑，让我手里的游戏手柄差点掉在地上。</p>
<p>之后的每一天，我都找各种理由去林浩家。林浩以为我突然对游戏上瘾了，其实我根本心不在焉。我偷偷观察她的一举一动——她习惯在阳台上画画，阳光斜斜地照在她侧脸上，她专注的样子美得像一幅油画；她喜欢喝茶，泡茶的时候会眯起眼睛闻茶叶的香气；她说话时会不自觉地用日语夹杂一两个词，然后反应过来，害羞地吐一下舌头。</p>
<p>有一天下午，林浩被妈妈叫去买东西，客厅里只剩下我和她。我紧张得手心都在出汗，不知道该说什么。她倒是很自然地开口问我："你喜欢画画吗？"</p>
<p>我摇了摇头。</p>
<p>"那你想看看我画的吗？"她站起来，领我去了她的临时画室——其实是林浩家的小书房。推开门的那一刻，我整个人愣住了。</p>
<p>墙上贴满了素描，画的是各种各样的场景：两个男孩在客厅打游戏、男孩在阳台上发呆、男孩侧着脸在笑——那个男孩，每一张画里都是同一个人。那个人，是我。</p>
<p>我僵在原地，脸烧得像烧红的铁。她站在我身后，声音很轻："你的轮廓很好看，很有少年感，我不自觉地就一直在画你。抱歉，是不是冒犯到你了？"</p>
<p>"没、没有。"我的声音抖得不像话。那天之后，我们之间多了一种奇妙的默契。我们什么都没说破，但空气中有一种温柔的张力。她会在画画时让我坐在旁边看书，会在我走的时候说"明天还来吗"，会在发现我在看她的时候，微微地翘起嘴角。</p>
<p>暑假结束的前一天，她递给我一幅画——是我的侧脸素描，右下角用铅笔写了一行小字："愿你永远保持这份纯真。"</p>
<p>后来那幅画被我裱起来，放在书桌上。直到今天，每次看到它，我都会想起那个夏天的午后，阳光、茶香、和一个偷偷画我的女孩。她教会我的，不只是什么是喜欢，更是如何在青春里，欣赏和珍藏一份不需要结果的温柔。</p>`,
    category: '情感故事',
    categorySlug: 'qinggan-gushi',
    author: '心语',
    date: '2026-07-25',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Artistic%20sketch%20studio%20scene%20with%20warm%20sunlight%2C%20easel%20and%20drawings%20on%20the%20wall%2C%20soft%20cream%20and%20warm%20gray%20color%20palette%2C%20nostalgic%20youth%20aesthetic%2C%20delicate%20illustration%20style%2C%20tender%20emotional%20atmosphere%2C%20Japanese%20slice%20of%20life%20vibe%2C%20gentle%20lighting&width=800&height=500&seq=article-3-01&orientation=landscape',
    tags: ['暗恋故事', '画画', '夏天的记忆', '纯真'],
    readTime: 9,
    featured: true,
  },
  {
    id: 'article-4',
    title: '从暗恋到成长：朋友姐姐型情感对自我塑造的影响',
    excerpt: '暗恋朋友的姐姐不只是青春期的荷尔蒙冲动，它在无形中塑造着少年的自我认知、审美偏好和情感模式。这篇文章带你重新审视那段"无用"的暗恋中隐藏的成长密码。',
    content: `<p>很多人回忆起青春期那段暗恋朋友的姐姐的经历时，总会笑着说"那时候真傻"。但如果从心理学角度深入剖析，你会发现这段看似"无用"的单向情感，实际上在悄无声息中完成了一场深度的自我塑造。</p>
<p><strong>审美体系的建立</strong></p>
<p>朋友的姐姐通常是我们生命中第一个"理想女性"的具象化符号。她的穿衣风格、言谈举止、兴趣爱好，都会在少年的审美系统中留下深刻的烙印。心理学研究表明，青春期早期的情感投射对象，会对一个人一生的审美偏好产生深远影响。这意味着，很多年后你被某个类型的女性吸引，可能正是因为你从她身上看到了当年那个"姐姐"的影子。</p>
<p><strong>自我要求的提升</strong></p>
<p>暗恋一个比自己优秀的人，会下意识地驱动自我提升。因为你希望在她面前"不丢人"，你会开始注意自己的穿着、努力学习、培养才艺。很多男生在暗恋朋友的姐姐期间，都经历了成绩突飞猛进的"神奇阶段"——这不是巧合，而是一种积极的情感驱动力在起作用。</p>
<p><strong>情感表达的启蒙</strong></p>
<p>朋友的姐姐型暗恋也是情感表达能力的启蒙课堂。你学会了如何隐藏心意、如何在恰当的距离表达关心、如何用眼神和微小的举动传递情感。这些"情感技能"虽然在当时只是单向的投射，但它们为你日后的情感交往打下了细腻的基础。</p>
<p><strong>独立人格的觉醒</strong></p>
<p>这段暗恋最终指向的其实不是她，而是你自己。当你从那段暗恋中走出来的时候，你开始意识到——原来喜欢一个人可以只是喜欢，不需要占有；原来有些感情的美好恰恰在于它的不可能。这种领悟，标志着一个人情感认知的成熟和独立人格的觉醒。</p>
<p>所以，那段暗恋从来不是"浪费时间"。它是你送给自己的一份成长礼物——藏在心底的秘密，最终化作了更好的自己。</p>`,
    category: '心理分析',
    categorySlug: 'xinli-fenxi',
    author: '心语',
    date: '2026-07-20',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Abstract%20growth%20and%20self-discovery%20concept%20art%2C%20warm%20gradient%20background%2C%20flowing%20organic%20shapes%20in%20amber%20and%20cream%20tones%2C%20silhouette%20of%20a%20young%20person%20looking%20forward%2C%20dreamy%20and%20inspirational%20atmosphere%2C%20artistic%20illustration%20style%2C%20minimalist%20composition&width=800&height=500&seq=article-4-01&orientation=landscape',
    tags: ['自我成长', '情感心理', '个人发展', '青春'],
    readTime: 7,
    featured: false,
  },
  {
    id: 'article-5',
    title: '当朋友的姐姐成了我的初恋——一段跨越五年的故事',
    excerpt: '大多数人都只是"暗恋"，但我和她之间，真的发生了一段故事。从偷偷喜欢到鼓起勇气表白，再到后来的分离和成长，这是我一生中最珍贵的记忆。',
    content: `<p>我叫阿哲，今年二十五岁。如果要我用一个词来形容我的青春，那个词一定是"小雅姐"。</p>
<p>小雅姐是我发小浩然的姐姐，比我大四岁。小时候我几乎天天泡在浩然家，小雅姐就是那个总给我们削苹果、辅导作业的大姐姐。那时候我只是觉得她好看，还没有别的想法。</p>
<p>真正意识到自己喜欢她，是初三那年。有一天放学，我在校门口看到一个男生给小雅姐送花，她笑着接过去了。我站在远处看着这一幕，胸口突然像被什么堵住了，难受得说不出话。从那天起我才明白——我对小雅姐的感情，早就不再是"姐姐"那么简单了。</p>
<p>我开始偷偷地关注她的一切。她喜欢穿白色裙子，爱看三毛的书，笑起来露出一颗小虎牙。我甚至把她朋友圈里三年前的照片都翻了一个遍，像个侦探一样拼凑她的生活轨迹。浩然完全不知道我的心思，还经常拉我去他家打游戏，我表面镇定地打着王者荣耀，耳朵却竖得老高，捕捉她房间里传来的每一点声响。</p>
<p>真正让我下定决心表白的，是大一的那个春节。我在外地上大学，寒假回家时浩然约我去他家吃饭。饭桌上，小雅姐坐在我对面，她已经毕业工作了，穿着职业装，比记忆中更加优雅从容。她给我夹了一块排骨，笑着说："阿哲长大了，变帅了。"</p>
<p>就是这句话，让我整整失眠了三天。</p>
<p>第四天晚上，我在微信上打了一千多字的表白，删除又重写，最后只发了七个字："小雅姐，我喜欢你。"</p>
<p>她过了很久才回复，只有三个字："我知道。"</p>
<p>后来我才知道，她其实早就察觉到了。那些年我的欲言又止、脸红心跳、刻意回避和偷偷关注，她都看在眼里。但她很聪明，她没有戳破，而是小心翼翼地维护着我们之间那份微妙的平衡。</p>
<p>我们在那个寒假短暂地"在一起"过。所谓的在一起，其实就是一起看了两场电影，在公园里散了一次步，以及在她家楼下交换了一个蜻蜓点水般的拥抱。时间短暂得像一场梦。</p>
<p>但我们最终没有走到一起。不是因为不喜欢，而是因为我们都知道，四岁的差距和"朋友姐姐"这个身份，对两个处在完全不同人生阶段的人来说，是一道难以跨越的鸿沟。</p>
<p>后来我有了女朋友，她也结婚了。我们偶尔还会联系，节日时互发祝福，朋友圈偶尔点赞。那段短暂的故事，像我们共同守护的一个温暖秘密，谁都没有再提起，但谁都没有忘记。</p>
<p>我想说的是，有些感情最好的归宿不是在一起，而是把它放在心里最干净的那个角落，让它成为你在面对这世界的残酷时，可以拿出来取暖的一点光。</p>`,
    category: '成长记忆',
    categorySlug: 'chengzhang-jiyi',
    author: '心语',
    date: '2026-07-15',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Winter%20evening%20scene%20with%20warm%20indoor%20lighting%2C%20two%20young%20people%20walking%20in%20park%20at%20dusk%2C%20soft%20romantic%20atmosphere%2C%20Chinese%20urban%20park%20with%20bare%20trees%2C%20warm%20amber%20streetlights%2C%20tender%20emotional%20mood%2C%20cinematic%20lighting%2C%20nostalgic%20youth%20romance%20aesthetic&width=800&height=500&seq=article-5-01&orientation=landscape',
    tags: ['初恋故事', '真实经历', '表白', '成长'],
    readTime: 12,
    featured: true,
  },
  {
    id: 'article-6',
    title: '你暗恋过的那个姐姐，后来怎么样了？',
    excerpt: '我们在社交媒体上发起了征集，收到了上千条回复。这些关于"朋友的姐姐"的真实故事，有的温暖、有的遗憾、有的令人泪目。每一个故事背后，都是一段独一无二的青春。',
    content: `<p>上个月，我们在社交平台上发起了一个话题征集："你小时候暗恋过的那个朋友的姐姐，后来怎么样了？"</p>
<p>短短一周，我们收到了超过三千条回复。读者们分享的故事里，有欢笑、有眼泪、有遗憾，也有令人意想不到的转折。我们精选了一些最打动人心的故事，与你分享。</p>
<p><strong>@北方的风：</strong>"初三暗恋了哥们的姐姐两年。她后来去了北京读大学，我高考志愿全填的北京。到了北京后发现她已经有男朋友了（大哭）。但我因此考上了好大学，现在在北京工作。谢谢你，不知名的姐姐。"</p>
<p><strong>@夏日汽水：</strong>"朋友的姐姐是我见过最温柔的人。她后来得了一场病，去世的时候才28岁。我现在每次回老家，都会去她墓前放一束花。她可能永远不知道有个小男孩偷偷喜欢过她，但我会一直记得她。"</p>
<p><strong>@阿树：</strong>"说出来你们可能不信——我娶了她。我暗恋了我兄弟的姐姐八年，大二那年终于鼓起勇气追她。过程很艰难，但我们坚持下来了。今年是我们结婚第三年，儿子刚满一岁。她到现在还笑话我，说当年就看出我每次去她家都紧张得同手同脚。"</p>
<p><strong>@深海里的光：</strong>"她出国了，嫁给了一个美国人。我偶尔会在ins上看她的动态，她过得很好。说不上还喜欢，但每次看到她的笑容，还是会觉得心里暖暖的。可能这就是青春吧——不是因为还爱着，而是因为那段记忆太美好了，所以永远希望她幸福。"</p>
<p><strong>@风继续吹：</strong>"我从没跟任何人说过这件事。她是朋友的表姐，我只见过她三次，但三次都让我心跳加速到快要窒息。后来朋友搬家了，我再也没见过她。我甚至不知道她的全名。但二十多年过去了，我还能清楚记得她的笑容。这大概就是暗恋的魔力吧——不需要结果，只需要存在过。"</p>
<p>读着这些故事，你会发现——朋友的姐姐，不只是一个人，而是我们青春里共同的符号。她代表了我们最初对美好的向往，第一次心动时的慌张，以及那份不掺杂任何杂质的纯粹喜欢。</p>
<p>无论后来怎样，感谢那个姐姐，曾途径我们的青春。</p>`,
    category: '成长记忆',
    categorySlug: 'chengzhang-jiyi',
    author: '心语',
    date: '2026-07-10',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Collection%20of%20warm%20memory%20fragments%20collage%20style%2C%20soft%20pastel%20amber%20and%20cream%20background%2C%20faded%20photographs%20and%20handwritten%20letters%2C%20nostalgic%20scrapbook%20aesthetic%2C%20tender%20emotional%20atmosphere%2C%20artistic%20illustration%2C%20warm%20lighting&width=800&height=500&seq=article-6-01&orientation=landscape',
    tags: ['读者故事', '真实征集', '青春记忆', '暗恋'],
    readTime: 10,
    featured: true,
  },
  {
    id: 'article-7',
    title: '青春文学：给那个永远不会知道我喜欢你的姐姐',
    excerpt: '一篇写给青春暗恋的散文诗。如果你也曾偷偷喜欢过一个人的姐姐，这篇文章，是写给你的。',
    content: `<p>你不知道我喜欢你。</p>
<p>就像你不知道每次我去张浩家，其实不是因为想和他打游戏，而是因为想见你。</p>
<p>你不知道我有意无意地打听你的近况——你考的学校、你的工作、你喜欢的那个人。你更不知道，每一条关于你的消息，都像一颗石头投入我的心湖，激起层层涟漪。</p>
<p>我只见过你五次。</p>
<p>第一次，你穿着校服，扎着马尾，从房间里走出来倒水。你看了我一眼，说了句"你是张浩的同学吧"，然后就回房间了。那句话只有六个字，但我在心里重复了一整个晚上。</p>
<p>第二次，你在客厅看电视，我坐在离你最远的那个沙发上。电视里放的什么我完全不记得，但你的侧脸轮廓，我到现在闭上眼睛还能画出来。</p>
<p>第三次，你过生日，张浩叫了一群朋友来家里。我送了最不起眼的一份礼物——一个普通的笔记本。你不知道的是，那个笔记本的扉页上，我用铅笔写了一行又擦掉的字。我写了又擦，擦了又写，最后什么都没留下。</p>
<p>第四次，你失恋了，坐在阳台上哭。我从张浩房间的窗户看到你的背影，肩膀一抖一抖的。那一瞬间，我特别想走过去，给你递一张纸巾，哪怕被你骂多管闲事也好。但我没有。我只是站在原地，攥紧了拳头，心里默默地恨那个让你哭的人。</p>
<p>第五次，也是最后一次。你来参加张浩的毕业聚会，带着你的新婚丈夫。你穿着红色的裙子，笑得很开心。我远远地看着你，在心里对你说了声"再见"。</p>
<p>你不知道我喜欢你。你也永远不会知道。</p>
<p>因为喜欢你，只是我一个人的事。和你无关，和所有人无关。它是我青春里独自守护的一个秘密花园，里面种满了以你为名的花。</p>
<p>后来我有了自己的爱人，有了新的人生。但偶尔，在某个深夜失眠的时候，我还是会想起你——想起那个扎着马尾、穿着校服的女孩。不是因为还爱着，而是因为想念那个奋不顾身去喜欢一个人的自己。</p>`,
    category: '青春文学',
    categorySlug: 'qingchun-wenxue',
    author: '心语',
    date: '2026-07-05',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Poetic%20nostalgic%20scene%20with%20soft%20dreamy%20lighting%2C%20a%20young%20person%20looking%20out%20window%20at%20sunset%2C%20warm%20amber%20and%20rose%20tones%2C%20literary%20atmosphere%2C%20watercolor%20illustration%20style%2C%20tender%20introspective%20mood%2C%20quiet%20contemplation&width=800&height=500&seq=article-7-01&orientation=landscape',
    tags: ['散文诗', '暗恋', '青春文学', '情感表达'],
    readTime: 6,
    featured: false,
  },
  {
    id: 'article-8',
    title: '暗恋朋友姐姐的十大特征：你中了几个？',
    excerpt: '自测一下，看看你是否曾经或正在经历这种特殊的青春情感。十种典型特征，带你重新认识那段藏在心底的暗恋。',
    content: `<p>几乎每个男生在青春期都经历过一段对朋友姐姐的特殊情感。这种情感介于崇拜和喜欢之间，微妙而深刻。我们总结了暗恋朋友姐姐的十大特征，来看看你中了几个？</p>
<p><strong>1. 去朋友家之前莫名紧张</strong></p>
<p>平常去朋友家随心所欲，但如果知道他姐姐在家，就会开始在意自己的发型、衣服，甚至提前想好要说什么。心跳从按门铃的那一刻就开始加速。</p>
<p><strong>2. 对朋友的一举一动格外关注</strong></p>
<p>不是因为关心朋友，而是因为朋友是获取姐姐信息的唯一渠道。你会"不经意"地打听她的近况——她最近忙什么、有没有男朋友、周末去哪里。</p>
<p><strong>3. 在朋友家表现异常乖巧</strong></p>
<p>平时大大咧咧的你，一到朋友家就变得礼貌、安静、懂事。主动帮忙收拾碗筷，说话声音都降了八度。原因只有一个——想在她面前留下好印象。</p>
<p><strong>4. 社交媒体上的"考古学家"</strong></p>
<p>你翻遍了她的朋友圈、微博、QQ空间，从三年前的第一条动态开始看起。你知道她的生日、她的星座、她喜欢吃什么、讨厌什么。你比她自己还了解她的社交轨迹。</p>
<p><strong>5. 莫名其妙地在意年龄差距</strong></p>
<p>你开始查"姐弟恋差几岁合适"、"女生会喜欢比自己小的男生吗"之类的问题。每次看到她的朋友中有同龄男生，心里就不舒服。</p>
<p><strong>6. 她的一个小动作能让你回味一整天</strong></p>
<p>她随口说的一句"你今天看起来不错"、她帮你倒了一杯水、她笑的时候看了你一眼——这些微不足道的小事，在你的世界里都变成了惊天动地的大事。</p>
<p><strong>7. 听她推荐的歌、看她推荐的书</strong></p>
<p>她随口提到的一首歌，你单曲循环了一个月。她朋友圈推荐的一本书，你第一时间下单。你企图通过这种方式，离她的世界更近一点。</p>
<p><strong>8. 嫉妒心爆棚但不敢表现</strong></p>
<p>看到她有了男朋友，你心里酸得像打翻了醋坛子，但表面上还要笑着说"姐夫挺好的"。没有人知道你在被窝里难受了多久。</p>
<p><strong>9. 幻想过无数次告白的场景</strong></p>
<p>你已经在脑海里演练了一百种告白方式——在夕阳下、在雨中、在她生日那天。但每一次，话到了嘴边又咽了回去。你知道你不会真的说出口，但你控制不住去想。</p>
<p><strong>10. 多年后想起她，心里还是会微微一颤</strong></p>
<p>即使你已经不再是当年那个青涩少年，即使你有了自己的感情生活。但每次想起她，心底还是会涌起一股温柔的暖流。那是对青春的怀念，也是对那段纯粹暗恋的致敬。</p>
<p>中了5个以上？恭喜你，你拥有了一段完整而珍贵的青春暗恋体验。这段经历不是"遗憾"，而是你情感成长过程中最美的礼物。</p>`,
    category: '心理分析',
    categorySlug: 'xinli-fenxi',
    author: '心语',
    date: '2026-06-30',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Playful%20checklist%20concept%20art%2C%20warm%20amber%20background%20with%20hand-drawn%20elements%2C%20soft%20illustration%20style%2C%20notebook%20paper%20texture%2C%20whimsical%20youth%20aesthetic%2C%20tender%20and%20lighthearted%20mood%2C%20minimalist%20composition%20with%20warm%20cream%20tones&width=800&height=500&seq=article-8-01&orientation=landscape',
    tags: ['自测', '特征分析', '暗恋', '趣味'],
    readTime: 7,
    featured: false,
  },
  {
    id: 'article-9',
    title: '她走后我才明白：暗恋朋友的姐姐是一场关于告别的练习',
    excerpt: '朋友姐姐的特别之处在于——她注定要离开。她上大学、工作、结婚、搬走。每一次告别，都是少年的情感第一课。',
    content: `<p>朋友的姐姐，大概是青春期里我们遇到的第一个"注定要离开的人"。</p>
<p>她不会永远住在你朋友家里，不会永远在那个城市，不会永远是那个你推开门就能见到的人。她会去远方上大学，会去别的城市工作，会嫁人，会拥有和你完全无关的人生。而你，注定要在某一刻，学会和她说再见。</p>
<p>我第一次经历告别，是高一那年。</p>
<p>朋友陈浩的姐姐陈婉考上了上海的大学。在那个小城里，"去上海读书"是一件了不起的事情。所有人都在恭喜陈婉，陈浩也很骄傲，逢人就说"我姐要去复旦了"。</p>
<p>只有我一个人，在听到这个消息时心里突然空了一大块。</p>
<p>陈婉走的那天，我找了个借口没有去送。我站在自己家的阳台上，看着远处陈家楼下的那辆出租车。我看到她拖着行李箱走出来，拥抱了陈浩，和陈叔叔陈阿姨告别，然后上了车。车子发动的那一刻，我的眼泪毫无征兆地掉了下来。</p>
<p>我知道自己的眼泪很可笑——我甚至没有资格为她哭。我不是她的谁，我们之间连一段正式的对话都屈指可数。但那个下午，十四岁的我在阳台上哭得像个傻子。</p>
<p>后来我明白了，我哭的不是她离开，而是我自己的青春正在经历第一场关于"失去"的预演。</p>
<p>朋友的姐姐注定要离开，这是她角色设定的一部分。而那段暗恋中最珍贵的部分，恰恰不是"喜欢"本身，而是通过这场注定无果的暗恋，我们提前学会了说再见。</p>
<p>后来的生活里，我们还会经历很多次告别。有些人离开是因为毕业，有些人离开是因为吵架，有些人离开是因为死亡。每一次告别都像一把刀，在心上刻下一道痕迹。但因为少年时代的那场暗恋，我们多少学会了如何面对告别——知道有些人的出现就是为了离开，知道告别之后生活还会继续，知道即使不在一起了，那段记忆也会永远温暖。</p>
<p>她走后我才明白，暗恋朋友的姐姐，是青春赠予我的一场关于告别的预习课。</p>`,
    category: '成长记忆',
    categorySlug: 'chengzhang-jiyi',
    author: '心语',
    date: '2026-06-25',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Farewell%20scene%20at%20train%20station%20or%20road%2C%20warm%20golden%20sunset%20lighting%2C%20nostalgic%20goodbye%20atmosphere%2C%20soft%20focus%20background%2C%20amber%20and%20cream%20color%20palette%2C%20emotional%20parting%20mood%2C%20artistic%20illustration%20style%2C%20tender%20melancholy%20aesthetic&width=800&height=500&seq=article-9-01&orientation=landscape',
    tags: ['告别', '成长', '离别', '情感记忆'],
    readTime: 8,
    featured: false,
  },
  {
    id: 'article-10',
    title: '青春小说推荐：那些关于暗恋与成长的故事',
    excerpt: '如果你喜欢这个主题，这些关于青春暗恋与成长的文学作品，一定会触动你内心最柔软的地方。',
    content: `<p>暗恋朋友的姐姐这个主题之所以动人，是因为它承载了青春中最纯粹的情感——不求回报的喜欢、无处安放的悸动、以及那些只有自己知道的小秘密。在文学作品中，这样的主题同样被反复书写。以下是几本关于青春暗恋与成长的经典作品推荐。</p>
<p><strong>《情书》——岩井俊二</strong></p>
<p>日本作家岩井俊二的经典之作。故事以一封寄往天国的情书开始，引出一段尘封多年的青春暗恋。书中那种细腻到极致的情感描写，几乎可以看作是"暗恋文学"的巅峰之作。"你好吗？我很好。"——这句简短的对白，包含了多少未曾说出口的喜欢。</p>
<p><strong>《挪威的森林》——村上春树</strong></p>
<p>村上春树的代表作，讲述了一段跨越青春与死亡的复杂情感故事。虽然不完全是暗恋主题，但书中对青春期情感的细腻刻画——那种朦胧、脆弱、深刻的感觉，与暗恋朋友的姐姐时的心理状态高度吻合。</p>
<p><strong>《左耳》——饶雪漫</strong></p>
<p>中国青春文学的代表作之一。书中描写的青春期情感——暗恋、喜欢、错过、成长——充满了真实的力量。特别是对少男少女内心世界的刻画，精准地捕捉到了那个年纪特有的敏感和多情。</p>
<p><strong>《匆匆那年》——九夜茴</strong></p>
<p>一部关于80后青春与成长的小说。书中那些关于暗恋、关于第一次心动的描写，能让每一个有过类似经历的人产生强烈共鸣。它让你想起自己的青春里那些"只敢偷偷喜欢"的人。</p>
<p><strong>《以你的名字呼唤我》——安德烈·艾席蒙</strong></p>
<p>虽然主题不同，但书中对暗恋心理的描写堪称教科书级别——那种小心翼翼的试探、患得患失的紧张、以及沉溺其中的甜蜜，与任何形式的青春暗恋都是相通的。</p>
<p>这些书，每一本都是关于青春暗恋的绝美注脚。如果你正处在那段"偷偷喜欢一个人"的时光里，或者想重温那段记忆，不妨找一本来读。也许书中的某段话，恰好能说中你心里那个藏了很久的秘密。</p>`,
    category: '青春文学',
    categorySlug: 'qingchun-wenxue',
    author: '心语',
    date: '2026-06-20',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Stack%20of%20books%20on%20wooden%20desk%20with%20warm%20reading%20lamp%20light%2C%20cozy%20literary%20atmosphere%2C%20soft%20cream%20and%20amber%20tones%2C%20vintage%20bookstore%20vibe%2C%20artistic%20illustration%20style%2C%20peaceful%20reading%20nook%2C%20warm%20natural%20lighting&width=800&height=500&seq=article-10-01&orientation=landscape',
    tags: ['书单推荐', '青春文学', '暗恋主题', '阅读'],
    readTime: 6,
    featured: false,
  },
  {
    id: 'article-11',
    title: '那些年我们以为的"喜欢"，其实是青春的第一次自我觉醒',
    excerpt: '重新审视那段"暗恋朋友姐姐"的经历，你会发现——你喜欢的不是她，而是那个因为喜欢她而变得更好的自己。',
    content: `<p>心理学中有个有趣的理论：青春期的第一次暗恋，本质上是一次"自我觉醒"的投射。</p>
<p>简单来说，你以为你在喜欢她，其实你是在通过"喜欢她"这个过程，重新认识自己。你喜欢的不是她——你喜欢的，是那个"正在喜欢一个人的自己"。</p>
<p>听起来有点绕？让我慢慢说。</p>
<p>青春期是一个特殊的阶段。在这个阶段，少年的自我意识开始萌发——"我是谁"、"我喜欢什么"、"我想要成为什么样的人"——这些问题第一次变得真实而迫切。但直接面对"我是谁"这个问题太难了，于是心理机制找到了一个聪明的"迂回策略"——通过喜欢一个人，来认识自己。</p>
<p>当你暗恋朋友的姐姐时：</p>
<p>你开始在意自己的外表——这其实是你在探索"我想在别人眼中是什么样的"。</p>
<p>你开始努力学习——这其实是你在确认"我有能力成为更好的人"。</p>
<p>你开始体验那些复杂的情绪——甜蜜、酸涩、嫉妒、期待、失落——这其实是你在建立自己的情感认知地图。</p>
<p>所以，那个被你暗恋的姐姐，其实是你的"镜子"。你通过这面镜子，第一次看到了完整的自己——一个有欲望、有情感、有追求的真实自我。</p>
<p>这就是为什么很多人在多年后回忆起那段暗恋时，并不觉得痛苦或遗憾，反而充满了温暖和感激。因为你感激的不是她，而是那个因为你喜欢她而拼命变好的自己。</p>
<p>青春期的第一场暗恋，是送给自己的成长仪式。在那场仪式中，你戴上了一个名为"喜欢"的面具，却在面具背后，悄然完成了从孩子到少年的蜕变。</p>`,
    category: '心理分析',
    categorySlug: 'xinli-fenxi',
    author: '心语',
    date: '2026-06-15',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Mirror%20reflection%20concept%20art%2C%20young%20person%20looking%20at%20reflection%20in%20warm%20light%2C%20self-discovery%20theme%2C%20amber%20and%20cream%20color%20palette%2C%20soft%20dreamy%20atmosphere%2C%20artistic%20illustration%20style%2C%20introspective%20mood%2C%20minimalist%20composition&width=800&height=500&seq=article-11-01&orientation=landscape',
    tags: ['自我觉醒', '心理分析', '成长', '暗恋本质'],
    readTime: 5,
    featured: false,
  },
  {
    id: 'article-12',
    title: '写给你——那个曾经让我心动的姐姐',
    excerpt: '一封永远不会寄出的信。写给青春里那个朋友姐姐的坦白书，写给曾经那个勇敢去喜欢一个人的自己。',
    content: `<p>亲爱的姐姐：</p>
<p>你好。请允许我叫你一声"姐姐"，虽然我知道，你永远不会看到这封信。</p>
<p>写下这些字的我，已经不是当年那个在你面前紧张得说不出话的小男生了。我长大了，有了自己的工作和生活，甚至开始被别人叫做"叔叔"。但每次想起你，我还是会变回那个十四岁的少年——那个在你家客厅坐立不安、在你面前笨拙地找不到话说、在你转身离开后偷偷看你背影的少年。</p>
<p>你可能不记得了。有一次我在你家写作业，你路过客厅时停下来，看了一眼我的数学试卷，然后弯下腰，用铅笔在我的草稿纸上画了一条辅助线。"这样想就简单了"，你说完就走了。那张草稿纸我没有扔掉，一直夹在课本里，直到纸张泛黄、铅笔痕迹模糊。</p>
<p>还有一次，你刚从外面回来，头发被雨水打湿了。你一边用毛巾擦头发，一边抱怨天气。那个画面我现在还记得——湿漉漉的刘海贴在额头上，你嘟着嘴生气的样子特别可爱。我表面上在认真地看一本漫画，实际上一个字都没看进去。</p>
<p>你教过我很多事情。</p>
<p>你教我如何有礼貌地和长辈说话——虽然你只是在示范给弟弟看，但我在旁边偷偷学会了。你教我遇到喜欢的女生应该勇敢去追——虽然你是对小磊说的，但我在心里偷偷记下了。你教我人应该有自己的爱好和追求——虽然那是你在餐桌上随口聊起的，但那天晚上我在日记本上写下了"我也要成为一个有趣的人"。</p>
<p>你更教会了我——喜欢一个人可以只是喜欢，不需要回报，不需要结果。因为喜欢本身就是一件足够美好的事情。</p>
<p>谢谢你，姐姐。谢谢你没有戳破我的小心思，谢谢你用你的温柔保护了一个敏感少年的自尊心。谢谢你的存在，让我的青春有了一束值得仰望的光。</p>
<p>这封信永远不会寄出。因为写它的目的不是让你知道，而是让我自己知道——那段时光，我真实地活过，真实地喜欢过，真实地因为喜欢一个人而变成了更好的人。</p>
<p>愿你永远平安喜乐。</p>
<p>曾经偷偷喜欢过你的那个弟弟</p>`,
    category: '青春文学',
    categorySlug: 'qingchun-wenxue',
    author: '心语',
    date: '2026-06-10',
    imageUrl: 'https://catscloud.cn/api/search-image?query=Handwritten%20letter%20on%20warm%20wooden%20desk%20with%20sunlight%2C%20vintage%20paper%20texture%2C%20fountain%20pen%2C%20soft%20amber%20and%20cream%20tones%2C%20nostalgic%20letter%20writing%20atmosphere%2C%20artistic%20illustration%20style%2C%20tender%20emotional%20mood%2C%20warm%20natural%20lighting&width=800&height=500&seq=article-12-01&orientation=landscape',
    tags: ['书信', '告白', '青春文学', '感谢信'],
    readTime: 6,
    featured: false,
  },
];